import en from './en/en.json';
import fr from './fr/fr.json';

export default { en, fr };
